module.exports = __webpack_public_path__ + "img/9788960174078.8c070d08.jpg";